import { render } from "./HomeAdditionHMUpgrade.vue?vue&type=template&id=77ed0f53"
import script from "./HomeAdditionHMUpgrade.vue?vue&type=script&lang=js"
export * from "./HomeAdditionHMUpgrade.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__